// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b2Afy","left":"styles_left__LYQGw"};